module.exports = __webpack_public_path__ + "static/media/icon-pill-table-tennis.79627a9c.svg";